import * as React from "react";
import {
  Box,
  Typography,
  Container,
  Divider,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { Link } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import pages from "../schemas/pages";

export default function Footer() {
  return (
    <>
      {/* Gold top accent */}
      <Box
        sx={{
          height: 4,
          background: "linear-gradient(90deg, #005B3B 0%, #D4AE60 50%, #005B3B 100%)",
        }}
      />

      <Box
        sx={{
          background: "linear-gradient(180deg, #0a2035 0%, #081A28 100%)",
          pt: { xs: 6, md: 8 },
          pb: { xs: 4, md: 6 },
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {/* Brand column */}
            <Grid xs={12} md={4}>
              <Box>
                <Box
                  component="img"
                  src="/photos/logo/logoBackgroundTrans.png"
                  sx={{
                    width: 180,
                    height: 64,
                    objectFit: "cover",
                    mb: 2,
                  }}
                  alt="Logo GGSinergi"
                />
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.7)",
                    fontSize: "14px",
                    fontFamily: "'Open Sans', sans-serif",
                    lineHeight: 1.8,
                    mb: 3,
                    maxWidth: 280,
                  }}
                >
                  PT Green Geo Sinergi — Professional mineral exploration
                  services provider, established in 2021 in Indonesia.
                </Typography>
                {/* Social icons */}
                <Box sx={{ display: "flex", gap: 1 }}>
                  <IconButton
                    component="a"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "rgba(255,255,255,0.6)",
                      border: "1px solid rgba(255,255,255,0.15)",
                      borderRadius: 1,
                      p: 1,
                      "&:hover": {
                        color: "#D4AE60",
                        borderColor: "#D4AE60",
                        background: "rgba(212,174,96,0.1)",
                      },
                      transition: "all 0.25s ease",
                    }}
                  >
                    <InstagramIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    component="a"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "rgba(255,255,255,0.6)",
                      border: "1px solid rgba(255,255,255,0.15)",
                      borderRadius: 1,
                      p: 1,
                      "&:hover": {
                        color: "#D4AE60",
                        borderColor: "#D4AE60",
                        background: "rgba(212,174,96,0.1)",
                      },
                      transition: "all 0.25s ease",
                    }}
                  >
                    <FacebookIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            </Grid>

            {/* Services column */}
            <Grid xs={12} sm={6} md={3}>
              <Typography
                sx={{
                  color: "#D4AE60",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 700,
                  fontSize: "12px",
                  letterSpacing: "2.5px",
                  textTransform: "uppercase",
                  mb: 2,
                }}
              >
                Our Services
              </Typography>
              <Box
                sx={{
                  width: 32,
                  height: 2,
                  background: "#D4AE60",
                  mb: 2.5,
                }}
              />
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                {pages.map((page, i) => (
                  <Link
                    key={i}
                    className="link-href"
                    style={{
                      color: "rgba(255,255,255,0.7)",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontFamily: "'Open Sans', sans-serif",
                    }}
                    to={`/${page.toLowerCase().split(" ").join("-")}`}
                  >
                    {page}
                  </Link>
                ))}
              </Box>
            </Grid>

            {/* Contact column */}
            <Grid xs={12} sm={6} md={5}>
              <Typography
                sx={{
                  color: "#D4AE60",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 700,
                  fontSize: "12px",
                  letterSpacing: "2.5px",
                  textTransform: "uppercase",
                  mb: 2,
                }}
              >
                Office Location
              </Typography>
              <Box
                sx={{
                  width: 32,
                  height: 2,
                  background: "#D4AE60",
                  mb: 2.5,
                }}
              />
              <Box
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  border: "1px solid rgba(255,255,255,0.15)",
                  borderRadius: 2,
                  lineHeight: 0,
                }}
              >
                <Box
                  component="iframe"
                  title="PT Green Geo Sinergi office location on Google Maps"
                  src="https://www.google.com/maps?q=-1.2149082,116.9004882&z=16&output=embed"
                  loading="lazy"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  sx={{
                    display: "block",
                    width: "100%",
                    height: { xs: 220, sm: 260 },
                    border: 0,
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mt: 6, mb: 3 }} />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: { xs: "column", sm: "row" },
              gap: 1,
            }}
          >
            <Typography
              sx={{
                color: "rgba(255,255,255,0.45)",
                fontSize: "13px",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              © {new Date().getFullYear()} PT Green Geo Sinergi. All Rights Reserved.
            </Typography>
            <Typography
              sx={{
                color: "rgba(255,255,255,0.3)",
                fontSize: "12px",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              Balikpapan, Indonesia
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
}
